import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
    const navigate = useNavigate();
    useEffect(() => {
        // If URL contains a shared folder link, let contentManager handle it (no forced login).
        const hash = window.location.hash || "";
        if (hash.includes("?folder=")) {
            navigate("/contentManager", { state: { keepHash: true }, replace: true });
            return;
        }

        const user = JSON.parse(localStorage.getItem("user") || "false");
        if (!user) {
            navigate("/login", { replace: true });
        } else {
            navigate("/contentManager", { replace: true });
        }
    }, []);

    return (
        <div
            style={{
                marginTop: 20
            }}
        >

        </div>
    );
};

export default Home;
